const checkout = (
  state = {
    loading: false
  },
  action
) => {
  switch (action.type) {
    case "TOGGLE_CHECKOUT_LOADING":
      return {
        loading: action.bool
      };
      case "CHECKOUT_SUCCESS":
        return {
          loading: false
        };
    default:
      return state;
  }
};
export default checkout;



// WEBPACK FOOTER //
// ./src/reducers/checkout.js